import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RowingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rowing"}/>
}
